import { gql } from '@apollo/client';
export const StatFeatureCustomFte = gql `
    fragment StatFeatureCustomFte on CustomFteFeatureSettingsFlags {
        enabled
        canOptIn
    }
`;
